import React, { useEffect, useState , useContext} from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import { makeStyles, lighten } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import AlertMessage from "../shared/alertMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./multipleTemplate.css";
import {LanguageContext, translateText} from '../shared/language'
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';




function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
function descendingNumberComparator(a, b, orderBy) {
  debugger;
  if (+b[orderBy] < +a[orderBy]) {
    return -1;
  }
  if (+b[orderBy] > +a[orderBy]) {
    return 1;
  }
  return 0;
}

function allColumnIsNumber(column, dataSet){
  let result = true;
  dataSet.forEach(row=>{
    debugger;

    if(isNaN(+row[column]) )
    {
      result = false;
    }
  })
  return result;
}

function getComparator(order, orderBy, dataSet) {
  if(allColumnIsNumber(orderBy, dataSet))
  {
    return order === "desc"
      ? (a, b) => descendingNumberComparator(a, b, orderBy)
      : (a, b) => -descendingNumberComparator(a, b, orderBy);
  }
  else{
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort, columns ,columnsTranslates} = props;
  const { userLanguage} = useContext(LanguageContext);

  const columnsLabelHandler=(key, index)=>{
    if(columnsTranslates){
      return columnsTranslates[userLanguage][index] || key;
    }
    else {
     return key
    }
}

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {columns.map((column, index) => (
          <TableCell
            key={column}
            align={"left"}
            padding={"default"}
            sortDirection={orderBy === column ? order : false}
          >
            <TableSortLabel
              active={orderBy === column}
              direction={orderBy === column ? order : "asc"}
              onClick={createSortHandler(column)}
            >
              {columnsLabelHandler(column, index)}
              {orderBy === column ? (
                <span
                  className={classes.visuallyHidden}
                  style={{ fontWeight: "bold" }}
                >
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { title, dataSet } = props;
  const { dictionary, userLanguage } = useContext(LanguageContext);

  const exportAsExcelFile=() =>{
    const json =  dataSet;
    const excelFileName = translateText(title,userLanguage);
    const worksheet = XLSX.utils.json_to_sheet(json);
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer= XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    saveAsExcelFile(excelBuffer, excelFileName);
  }
  const saveAsExcelFile=(buffer, fileName)=> {
     const data = new Blob([buffer], {type: EXCEL_TYPE});
     FileSaver.saveAs(data, fileName + new  Date().getTime() + EXCEL_EXTENSION);
  }


  return (
    <Toolbar
      className={clsx(classes.root)}
    >
      <div className="titulo__contenedor">
        <h2>{translateText(title,userLanguage)}</h2>
        <div className="titulo__acciones" onClick={exportAsExcelFile}>
          <FontAwesomeIcon icon="cloud-download-alt" />
          <span>{dictionary.textoDescarga}</span>
        </div>
      </div>
    </Toolbar>
  );
};



const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

export default function EnhancedTable({ result, titleProps, navigation, columnsProps }) {
  const [dataSet, setDataSet] = useState(result?.data_set);

  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const { dictionary } = useContext(LanguageContext);
  const [columns, setColumns] = useState(null);

  useEffect(() => {
    setDataSet(result?.data_set);
    setColumns(columnsProps)
  }, [result,columnsProps]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };




  if (dataSet && dataSet.length > 0) {
    return (
      <div className={classes.root}>
        <EnhancedTableToolbar title={titleProps} dataSet={dataSet} />
        <Paper className={classes.paper}>
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={dataSet.length}
                columns={Object.keys(dataSet[0])}
                columnsTranslates = {columns}
              />
              <TableBody>
                {stableSort(dataSet, getComparator(order, orderBy, dataSet))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow hover tabIndex={-1} key={row.name}>
                        {Object.values(row).map((value, index) => {
                          if (index === 0 && navigation) {
                            return (
                              <TableCell key={row.name + index}>
                                <Link
                                  to={`/${navigation.target}?${navigation.param}=${value}`}
                                >
                                  {value}
                                </Link>
                              </TableCell>
                            );
                          } else {
                            return <TableCell align="left">{value}</TableCell>;
                          }
                        })}
                      </TableRow>
                    );
                  })}
                {/* {emptyRows > 0 && (
                  <TableRow style={{ height: 33 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )} */}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[15, 30, 45]}
            component="div"
            count={dataSet.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            labelRowsPerPage={dictionary.contadorFilas}
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} Total: ${count}`}
          />
        </Paper>
      </div>
    );
  }
  if (dataSet && dataSet.length === 0) {
    return (
      <>
        <div className="titulo__contenedor">
          <h2>{titleProps}</h2>
        </div>
        <AlertMessage
          title={dictionary.tituloAlertaSinDatos}
          description={dictionary.descripcionAlertaSinDatos}
        />
      </>
    );
  }
}
